/**
 * Central API configuration.
 * All API base URL references should use this instead of process.env directly.
 */
export const API_URL = process.env.REACT_APP_API_URL;
